import select from 'dom-select';
import { getCookie, setCookie } from '@lib/cookies';

const COOKIE_PREFIX = 'vb_v';

export const videoBackground = (el) => {
  const ui = {
    el,
    videoBackground: select('.video-background'),
    videoPlay: select('.video-background__text'),
    video: el.querySelector('iframe[src*="www.youtube.com"], iframe[src*="player.vimeo.com"], video'),
    transcriptsToggle: select('.video-background__transcript-toggle'),
    transcriptsToggles: select.all('.video-background__transcript-toggle'),
    transcripts: select('.video-background__transcribed-content'),
  };

  // console.log(ui.transcriptsToggles);

  const addEvents = () => {

    if(typeof(ui.videoPlay) != 'undefined' && ui.videoPlay != null) {
      ui.videoPlay.addEventListener('click', () => {
        ui.videoBackground.classList.toggle('video-background--playing');
        ui.video.play();

        var videoId = ui.video.dataset.id;
        var cookieName = COOKIE_PREFIX.concat(videoId);
        setCookie(cookieName, videoId, 90);
      });
    } else {
    //  console.log('not a video variant');
    }

    ui.video.addEventListener('click', () => {
      if (ui.video.paused == true) {
        ui.video.play();
      }
      else {
        /*
        ui.video.pause();
        ui.videoBackground.classList.toggle('video-background--playing');
        */
      }
    });

    ui.transcriptsToggles.forEach(current => {
      current.addEventListener('click', () => {
        current.parentNode.classList.toggle('video-background--view-transcripts');
      });
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default videoBackground;
